"use strict";
var uncurryThis = require("../internals/function-uncurry-this-clause");
var aCallable = require("../internals/a-callable");
var NATIVE_BIND = require("../internals/function-bind-native");
var bind = uncurryThis(uncurryThis.bind);
module.exports = function(fn, that) {
  aCallable(fn);
  return that === void 0 ? fn : NATIVE_BIND ? bind(fn, that) : function() {
    return fn.apply(that, arguments);
  };
};
